import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiFacebook, FiInstagram, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  const links = {
    Services: ['SEO', 'Google Ads', 'Facebook Marketing', 'Web Design', 'Content Marketing', 'Reputation Management'],
    Company: ['About Us', 'Blog & Tips', 'Case Studies', 'Contact'],
    Legal: ['Privacy Policy', 'Terms of Service'],
  };

  return (
    <footer className="bg-[#4b4b4b] text-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            {/* Recreated Logo from Image */}
            <div className="inline-flex items-center gap-2 mb-6 border border-white/40 px-3 py-1.5">
              <div className="w-8 h-8 rounded-full border-2 border-[#5a8f2a] flex items-center justify-center relative">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 text-[#5a8f2a]">
                  <path d="M14 8h-4v8h4M10 12h3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 8c-2.21 0-4 1.79-4 4s1.79 4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <span className="text-xl md:text-2xl font-normal tracking-wide text-white">
                <span className="text-[#5a8f2a]">Get</span>Cleaning<span className="text-[#5a8f2a]">Clicks</span>
              </span>
            </div>
            
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              The #1 marketing agency specialized exclusively in growing cleaning businesses with SEO, Google Ads, Facebook, and Web Design.
            </p>
            <div className="flex items-center gap-3">
              {[FiFacebook, FiInstagram, FiLinkedin, FiTwitter].map((Icon, i) => (
                <a key={i} href="#" aria-label={['Facebook', 'Instagram', 'LinkedIn', 'Twitter'][i]} className="w-9 h-9 rounded-full bg-gray-600 flex items-center justify-center text-gray-300 hover:bg-[#5a8f2a] hover:text-white transition-all">
                  <Icon className="text-sm" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <h4 className="text-white font-bold mb-4">{category}</h4>
              <ul className="space-y-2.5">
                {items.map((item) => (
                  <li key={item}>
                    <a href="#" className="text-gray-300 hover:text-[#5a8f2a] text-sm transition-colors">{item}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-600 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-300 text-sm">© {new Date().getFullYear()} Get Cleaning Clicks. All rights reserved.</p>
          <p className="text-[#5a8f2a] text-xs font-semibold tracking-wide">Specialized Marketing for Cleaning Businesses.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;